import React from 'react';

const TipopreguntaData=[
  // {
  //   id:1,
  //   title:'---Seleccione tipo de pregunta---',
  // },
  { id:1, 
    title:'Matriz/escala valoración',
  },
  {
    id:2,
    title:'Opción múltiple',
  },
  {
    id:3,
    title:'Casillas de verificación',
  },
  {
    id: 4,
    title:'Campo texto simple',
  },
  {
    id: 5,
    title:'Campo texto libre',
  },
  {
    id: 6,
    title:'Menu desplegable',
  },
  {
    id: 7,
    title:'Valoración por estrellas',
  },
  {
    id:8,
    title:'Fecha/Hora'
  },
  // {
  //   id:9,
  //   title:'Verdadero y falso'
  // }
]
export default TipopreguntaData
